export const PROFILE_PATH = '/:entityName';

export const PROFILE_REPORTS_PATH = `${PROFILE_PATH}/reports`;
export const PROFILE_PROJECTS_PATH = `${PROFILE_PATH}/projects`;
export const PROFILE_STARS_PATH = `${PROFILE_PATH}/stars`;

export const TEAM_MEMBERS_PATH = `${PROFILE_PATH}/members`;
export const TEAM_SERVICE_ACCOUNTS_PATH = `${PROFILE_PATH}/service-accounts`;
export const TEAM_SETTINGS_PATH = `${PROFILE_PATH}/settings`;
